<template>
    <div class="index">
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="$t('Meter')" name="first">
                        <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                            <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea" :enablesys="'1'"
                                :comType="'signalr_curve'" @areaList="getAreaList"></areaSelect>
                            <!--                    <el-form-item label="信号">-->
                            <!--                        <el-select :placeholder="$t('el.select.placeholder')" v-model="formselect.signalInfo" filterable class="queryform">-->
                            <!--                            <el-option value="W" label="瞬时有功功率"></el-option>-->
                            <!--                            <el-option value="Ia" label="A相电流"></el-option>-->
                            <!--                            <el-option value="Ib" label="B相电流"></el-option>-->
                            <!--                            <el-option value="Ic" label="C相电流"></el-option>-->
                            <!--                            <el-option value="Uan" label="A相电压"></el-option>-->
                            <!--                            <el-option value="Ubn" label="B相电压"></el-option>-->
                            <!--                            <el-option value="Ucn" label="C相电压"></el-option>-->
                            <!--                            <el-option value="EP" label="瞬时总功率"></el-option>-->
                            <!--                            <el-option value="S" label="视载功率"></el-option>-->
                            <!--                            <el-option value="PF" label="功率因素"></el-option>-->
                            <!--                        </el-select>-->
                            <!--                    </el-form-item>-->
                            <!--                    <el-form-item label="时间段">-->
                            <!--                        <el-date-picker type="daterange"-->
                            <!--                                        v-model="selectTime"-->
                            <!--                                        value-format="yyyy-MM-dd HH:mm:ss"-->
                            <!--                                        range-separator="至"-->
                            <!--                                        start-placeholder="开始日期"-->
                            <!--                                        end-placeholder="结束日期">-->
                            <!--                        </el-date-picker>-->
                            <!--                    </el-form-item>-->
                            <el-form-item>
                                <el-button :loading="loading" @click="getData" type="primary">{{ $t('Query') }}</el-button>
                                <el-button @click="reset">{{ $t('Reset') }}</el-button>
                            </el-form-item>
                        </el-form>
                        <template>

                            <el-form style="margin-left:35%" v-show="formselect.deviceCode">
                                <el-form-item :label="$t('EquipmentCode') + ':'">{{ formselect.deviceCode }}</el-form-item>
                            </el-form>
                        </template>
                        <template>
                            <el-row>
                                <div class="echarts" id="chart5" style="height:220px;width:45%;display: inline-block;margin-left:10px;">
                                </div>
                                <div class="echarts" id="chart2"
                                    style="height:220px;width:45%;display: inline-block;margin-left:5%;"></div>
                            </el-row>
                            <el-row>
                                <div class="echarts" id="chart3" style="height:220px;width:45%;display: inline-block;margin-left:10px;">
                                </div>
                                <div class="echarts" id="chart4"
                                    style="height:220px;width:45%;display: inline-block;margin-left:5%;"></div>
                            </el-row>
                            <!-- <el-row>
                                <div class="echarts" id="chart5" style="height:220px;width:45%;"></div>
                            </el-row> -->
                        </template>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('THSensor')" name="second">
                        <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                            <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea" :enablesys="'1'"
                                :comType="'signalr_curve'" @areaList="getAreaList"></areaSelect>
                            <!--                    <el-form-item label="信号">-->
                            <!--                        <el-select :placeholder="$t('el.select.placeholder')" v-model="formselect.signalInfo" filterable class="queryform">-->
                            <!--                            <el-option value="W" label="瞬时有功功率"></el-option>-->
                            <!--                            <el-option value="Ia" label="A相电流"></el-option>-->
                            <!--                            <el-option value="Ib" label="B相电流"></el-option>-->
                            <!--                            <el-option value="Ic" label="C相电流"></el-option>-->
                            <!--                            <el-option value="Uan" label="A相电压"></el-option>-->
                            <!--                            <el-option value="Ubn" label="B相电压"></el-option>-->
                            <!--                            <el-option value="Ucn" label="C相电压"></el-option>-->
                            <!--                            <el-option value="EP" label="瞬时总功率"></el-option>-->
                            <!--                            <el-option value="S" label="视载功率"></el-option>-->
                            <!--                            <el-option value="PF" label="功率因素"></el-option>-->
                            <!--                        </el-select>-->
                            <!--                    </el-form-item>-->
                            <!--                    <el-form-item label="时间段">-->
                            <!--                        <el-date-picker type="daterange"-->
                            <!--                                        v-model="selectTime"-->
                            <!--                                        value-format="yyyy-MM-dd HH:mm:ss"-->
                            <!--                                        range-separator="至"-->
                            <!--                                        start-placeholder="开始日期"-->
                            <!--                                        end-placeholder="结束日期">-->
                            <!--                        </el-date-picker>-->
                            <!--                    </el-form-item>-->
                            <el-form-item>
                                <el-button :loading="loading1" @click="getData1" type="primary">{{ $t('Query')
                                }}</el-button>
                                <el-button @click="reset">{{ $t('Reset') }}</el-button>
                            </el-form-item>
                        </el-form>
                        <template>

                            <el-form style="margin-left:15%" v-show="formselect.deviceCode">
                                <el-form-item :label="$t('EquipmentCode') + ':'">{{ formselect.deviceName }}</el-form-item>
                            </el-form>
                        </template>
                        <template>
                            <el-row>
                                <div class="echarts" id="chart6" style="height:220px;width:32vw;display: inline-block;margin-left:10px;">
                                </div>

                            </el-row>
                            <!-- <el-row>
                                <div class="echarts" id="chart8"
                                     style="height:220px;width:32vw;display: inline-block;"></div>
                                <div class="echarts" id="chart9"
                                     style="height:220px;width:32vw;display: inline-blockmargin-left:5%;"></div>
                            </el-row> -->
                            <!-- <el-row>
                                <div class="echarts" id="chart5" style="height:220px;width:45%;"></div>
                            </el-row> -->
                        </template>
                    </el-tab-pane>
                </el-tabs>

            </el-main>
        </el-scrollbar>
    </div>
</template>

<script>
import * as signalR from "@microsoft/signalr";
import areaSelect from '../../components/content/maintabber/areaSelect'
import { mapState } from 'vuex';
import echarts from 'echarts'
import { GetCurveData, GetByDeviceCode, GetHumCurveData } from '../../api/api'
import { getLocalTime, getDeviceNameByid } from '../../utils/util'
import ElPager from "element-ui/packages/pagination/src/pager";
//let hubUrl = "https://nsbseelab-dev.chinacloudsites.cn/api/";
//let hubUrl = "http://nsbseelabdev-azurefunction.nokia-sbell.com/api/";
let hubUrl = process.env.VUE_APP_SignarlUrl;
const connection = new signalR.HubConnectionBuilder()
    .withAutomaticReconnect()//断线自动重连
    .withUrl(hubUrl)
    .configureLogging(signalR.LogLevel.Information)
    .build();
export default {
    name: "Signal_curve",
    components: {
        ElPager,
        areaSelect,
    },
    data() {
        return {
            activeName: "first",
            level: 5,
            deviceType: "",
            selectTime: "",
            xinhao: "",
            chart1: '',
            sel: '',
            formArea: { cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: "" },
            formselect: { deviceId: "", deviceCode: "", signalInfo: "", startTime: "", endTime: "", deviceName: "" },
            result: "",
            DataList: [],
            xData: [],
            DataList2: [],
            xData2: [],
            DataList3: [],
            xData3: [],
            DataList4: [],
            xData4: [],
            DataList5: [],
            xData5: [],
            Magnification: '',
            DataList6: [],
            DataList7: [],
            xData6: [],
            ElcDataList: [],
            THDataList: [],
            i: 0,
            x: 0,
            y: 0,
            z: 0,
            u: 0,
            h: 0,
            arr: [],
            arr2: [],
            arr3: [],
            arr4: [],
            arr5: [],
            arr5_A: [],
            arr5_B: [],
            arr5_C: [],
            arr6_A: [],
            arr6_B: [],
            arr6_C: [],
            arr7: [],
            arr7_W: [],
            arr7_S: [],
            arr8_W: [],
            arr8_S: [],
            arr9_Ua: [],
            arr9_Ub: [],
            arr9_Uc: [],
            arr9l_Ua: [],
            arr9l_Ub: [],
            arr9l_Uc: [],
            arr_t: [],
            arr_h: [],
            arr_time: [],
            loading: false,
            loading1: false,
        }
    },
    mounted() {
        //this.drawLine()
        if (this.activeName == 'first') {
            this.deviceType = 'ElectricMeter'
        } else {
            this.deviceType = 'TemHumSensor'
        }
        this.drawLine2()
        this.drawLine3()
        this.drawLine4()
        this.drawLine5()
        this.drawLine6()
        console.log("connecting...");
        console.log(connection);
        connection
            .start()
            .then(() => console.log("ready"))
            .catch(console.error);
        //this.showData();
    },
    destroyed() {

        connection.stop();
    },
    methods: {
        handleClick() {
            if (this.activeName == 'first') {
                this.deviceType = 'ElectricMeter'
            } else {
                this.deviceType = 'TemHumSensor'
            }
            this.formselect = { deviceId: "", deviceCode: "", signalInfo: "", startTime: "", endTime: "" }
            this.reset()
        },
        reset() {
            this.DataList = []
            this.xData = []
            this.DataList2 = []
            this.xData2 = []
            this.DataList3 = []
            this.xData3 = []
            this.DataList4 = []
            this.xData4 = []
            this.DataList5 = []
            this.xData5 = []
            this.DataList6 = []
            this.xData6 = []
            //this.drawLine()
            this.drawLine2()
            this.drawLine3()
            this.drawLine4()
            this.drawLine5()
            this.drawLine6()
            this.formArea = { cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: "" },
                this.formselect = { deviceId: "", deviceCode: "", signalInfo: "", startTime: "", endTime: "" }
            //connection.stop();
            clearInterval(this.sel);
        },
        ElcData(message) {
            //  

            this.formselect.deviceCode = message.dId
            this.ElcDataList.push(message)

            var iIdsList = message.iIds;
            var indexa = iIdsList.findIndex(value => value == 'Ia');
            var indexb = iIdsList.findIndex(value => value == 'Ib');
            var indexc = iIdsList.findIndex(value => value == 'Ic');
            var indexw = iIdsList.findIndex(value => value == 'W');
            var indexEp = iIdsList.findIndex(value => value == 'Ep');
            var indexPF = iIdsList.findIndex(value => value == 'PF');
            var indexs = iIdsList.findIndex(value => value == 'S');
            var indexua = iIdsList.findIndex(value => value == 'Uan');
            var indexub = iIdsList.findIndex(value => value == 'Ubn');
            var indexuc = iIdsList.findIndex(value => value == 'Ucn');
            var timestamp = getLocalTime(message.timestamp);
            var a = message.iValues[indexa] * this.Magnification;
            var b = message.iValues[indexb] * this.Magnification;
            var c = message.iValues[indexc] * this.Magnification;
            var w = message.iValues[indexw] * this.Magnification;
            var Ep = message.iValues[indexEp] * this.Magnification;
            var Pf = message.iValues[indexPF];
            var s = message.iValues[indexs] * this.Magnification;
            var ua = message.iValues[indexua];
            var ub = message.iValues[indexub];
            var uc = message.iValues[indexuc];
            this.arr.push(Ep)
            this.arr2.push(timestamp)

            this.arr3.push(Pf)
            this.arr4.push(timestamp)


            this.arr5_A.push(a)
            this.arr5_B.push(b)
            this.arr5_C.push(c)
            this.arr6_A.push(timestamp)
            this.arr6_B.push(timestamp)
            this.arr6_C.push(timestamp)

            this.arr7_W.push(w)
            this.arr7_S.push(s)
            this.arr8_W.push(timestamp)
            this.arr8_S.push(timestamp)

            this.arr9_Ua.push(ua);
            this.arr9_Ub.push(ub);
            this.arr9_Uc.push(uc);
            this.arr9l_Ua.push(timestamp)
            this.arr9l_Ub.push(timestamp)
            this.arr9l_Uc.push(timestamp)
            var that = this


            that.i = that.arr.length;
            that.x = that.arr3.length;
            that.y = that.arr5_A.length;
            that.z = that.arr7_W.length;
            that.u = that.arr9_Ua.length;
            //chart1
            if (that.i > 1000) {
                that.DataList = [that.arr.slice(that.i - 1000, that.i)]
                that.xData = that.arr2.slice(that.i - 1000, that.i)

            } else {
                that.DataList = [that.arr]
                that.xData = that.arr2
            }


            //chart2
            if (that.x > 1000) {
                that.DataList2 = [that.arr3.slice(that.x - 1000, that.x)]
                that.xData2 = that.arr4.slice(that.x - 1000, that.x)

            } else {
                that.DataList2 = [that.arr3]
                that.xData2 = that.arr4
            }
            //chart3
            if (that.y > 1000) {
                that.DataList3 = [that.arr5_A.slice(that.y - 1000, that.y), that.arr5_B.slice(that.y - 1000, that.y), that.arr5_C.slice(that.y - 1000, that.y)]
                that.xData3 = that.arr6_A.slice(that.y - 1000, that.y)
            } else {
                that.DataList3 = [that.arr5_A, that.arr5_B, that.arr5_C]
                that.xData3 = that.arr6_A
            }
            //chart4
            if (that.z > 1000) {
                that.DataList4 = [that.arr7_W.slice(that.z - 1000, that.z), that.arr7_S.slice(that.z - 1000, that.z)]
                that.xData4 = that.arr8_W.slice(that.z - 1000, that.z)
            } else {
                that.DataList4 = [that.arr7_W, that.arr7_S]
                that.xData4 = that.arr8_W
            }
            //chart5
            if (that.u > 1000) {
                that.DataList5 = [that.arr9_Ua.slice(that.u - 1000, that.u), that.arr9_Ub.slice(that.u - 1000, that.u), that.arr9_Uc.slice(that.u - 1000, that.u)]
                that.xData5 = that.arr9l_Ua.slice(that.u - 1000, that.u)
            } else {
                that.DataList5 = [that.arr9_Ua, that.arr9_Ub, that.arr9_Uc]
                that.xData5 = that.arr9l_Ua
            }
            this.xData2.sort(function (a, b) {
                return Date.parse(a) - Date.parse(b)
            });
            this.xData3.sort(function (a, b) {
                return Date.parse(a) - Date.parse(b)
            });
            this.xData4.sort(function (a, b) {
                return Date.parse(a) - Date.parse(b)
            });
            this.xData5.sort(function (a, b) {
                return Date.parse(a) - Date.parse(b)
            });

            that.$nextTick(() => {
                //that.drawLine()
                that.drawLine2()
                that.drawLine3()
                that.drawLine4()
                that.drawLine5()
            })


        },

        TempHumdata(message) {
            //  

            this.THDataList.push(message)
            this.formselect.deviceCode = message.dId
            var iIdsList1 = message.iIds;
            var indext = iIdsList1.findIndex(value => value == 'temp');
            var indexh = iIdsList1.findIndex(value => value == 'Hum');
            var timestamp1 = getLocalTime(message.timestamp);
            var t = message.iValues[indext];
            var h = message.iValues[indexh];
            this.arr_t.push(t)
            this.arr_h.push(h)

            this.arr_time.push(timestamp1)
            var that = this
            //this.xData.length=

            that.h = that.arr_t.length;
            this.xData.length = this.arr_time.length;
            if (that.h > 1000) {
                that.DataList6 = [that.arr_t.slice(that.h - 1000, that.h), that.arr_h.slice(that.h - 1000, that.h)]
                that.xData6 = that.arr_time.slice(that.h - 1000, that.h)
            } else {
                that.DataList6 = [that.arr_t, that.arr_h]
                that.xData6 = that.arr_time
            }
            that.$nextTick(() => {
                that.drawLine6()

            })
        },

        getData() {

            var that = this
            that.loading = true
            // this.formselect.startTime = this.selectTime[0]
            // this.formselect.endTime = this.selectTime[1]
            this.i = 0;
            if (!this.formselect.deviceId) {
                this.$message.warning(this.$t('PleaseSelectDevice'))
                that.loading = false
                return
            }
            this.formselect.deviceCode = getDeviceNameByid(this.formselect.deviceId, JSON.parse(sessionStorage.getItem("area"))).label

            GetByDeviceCode(this.formselect.deviceId).then(res => {
                if (res.success) {
                    this.Magnification = res.result.magnification;
                    connection.on(this.formselect.deviceCode, this.ElcData);
                }
            })

            // var i = 0, arr = [], arr2 = [], arr3 = [], arr4 = [], arr5 = [], arr5_A = [], arr5_B = [],
            //     arr5_C = [], arr6 = [], arr7 = [], arr7_W = [], arr7_S = [], arr8 = []
            var data = this.formselect
            GetCurveData(data).then(res => {
                if (res.success) {
                    if (that.sel) {
                        clearInterval(that.sel);
                    }
                    if (!res.result.epList) {

                    }
                    that.result = res.result

                    that.result.epList.map(item => {

                        let iTs = getLocalTime(item.iTs)
                        that.arr.push(item.iValue)
                        that.arr2.push(iTs)
                    })
                    that.result.pfList.map(item => {
                        item.iTs = getLocalTime(item.iTs)
                        that.arr3.push(item.iValue)
                        that.arr4.push(item.iTs)
                    })
                    //  
                    that.result.threeIaList.map(item => {
                        item.iTs = getLocalTime(item.iTs)
                        that.arr5_A.push(item.iValue)
                        that.arr6_A.push(item.iTs)
                    })

                    that.result.threeIbList.map(item => {
                        item.iTs = getLocalTime(item.iTs)
                        that.arr5_B.push(item.iValue)
                        that.arr6_B.push(item.iTs)
                    })

                    that.result.threeIcList.map(item => {
                        item.iTs = getLocalTime(item.iTs)
                        that.arr5_C.push(item.iValue)
                        that.arr6_C.push(item.iTs)
                    })

                    that.result.threeUList.map(item => {
                        item.iTs = getLocalTime(item.iTs)
                        if (item.type == 'Uan') {
                            that.arr9_Ua.push(item.iValue)
                            that.arr9l_Ua.push(item.iTs)
                        }
                        if (item.type == 'Ubn') {
                            that.arr9_Ub.push(item.iValue)
                            that.arr9l_Ub.push(item.iTs)
                        }
                        if (item.type == 'Ucn') {
                            that.arr9_Uc.push(item.iValue)
                            that.arr9l_Uc.push(item.iTs)
                        }

                    })

                    that.result.wsList.map(item => {
                        item.iTs = getLocalTime(item.iTs)
                        // arr7.push(item.iValue)
                        if (item.type == 'W') {
                            that.arr7_W.push(item.iValue)
                            that.arr8_W.push(item.iTs)
                        } else {
                            that.arr7_S.push(item.iValue)
                            that.arr8_S.push(item.iTs)
                        }

                    })

                    that.i = that.arr.length;
                    that.x = that.arr3.length;
                    that.y = that.arr5_A.length;
                    that.z = that.arr7_W.length;
                    that.u = that.arr9_Ua.length;
                    //chart1
                    if (that.i > 1000) {
                        that.DataList = [that.arr.slice(that.i - 1000, that.i)]
                        that.xData = that.arr2.slice(that.i - 1000, that.i)

                    } else {
                        that.DataList = [that.arr]
                        that.xData = that.arr2
                    }


                    //chart2
                    if (that.x > 1000) {
                        that.DataList2 = [that.arr3.slice(that.x - 1000, that.x)]
                        that.xData2 = that.arr4.slice(that.x - 1000, that.x)

                    } else {
                        that.DataList2 = [that.arr3]
                        that.xData2 = that.arr4
                    }
                    //chart3
                    if (that.y > 1000) {
                        that.DataList3 = [that.arr5_A.slice(that.y - 1000, that.y), that.arr5_B.slice(that.y - 1000, that.y), that.arr5_C.slice(that.y - 1000, that.y)]
                        that.xData3 = that.arr6_A.slice(that.y - 1000, that.y)
                    } else {
                        that.DataList3 = [that.arr5_A, that.arr5_B, that.arr5_C]
                        that.xData3 = that.arr6_A
                    }
                    //chart4
                    if (that.z > 1000) {
                        that.DataList4 = [that.arr7_W.slice(that.z - 1000, that.z), that.arr7_S.slice(that.z - 1000, that.z)]
                        that.xData4 = that.arr8_W.slice(that.z - 1000, that.z)
                    } else {
                        that.DataList4 = [that.arr7_W, that.arr7_S]
                        that.xData4 = that.arr8_W
                    }
                    //chart5
                    if (that.u > 1000) {
                        that.DataList5 = [that.arr9_Ua.slice(that.u - 1000, that.u), that.arr9_Ub.slice(that.u - 1000, that.u), that.arr9_Uc.slice(that.u - 1000, that.u)]
                        that.xData5 = that.arr9l_Ua.slice(that.u - 1000, that.u)
                    } else {
                        that.DataList5 = [that.arr9_Ua, that.arr9_Ub, that.arr9_Uc]
                        that.xData5 = that.arr9l_Ua
                    }
                    this.xData2.sort(function (a, b) {
                        return Date.parse(a) - Date.parse(b)
                    });
                    this.xData3.sort(function (a, b) {
                        return Date.parse(a) - Date.parse(b)
                    });
                    this.xData4.sort(function (a, b) {
                        return Date.parse(a) - Date.parse(b)
                    });
                    this.xData5.sort(function (a, b) {
                        return Date.parse(a) - Date.parse(b)
                    });

                    that.$nextTick(() => {
                        //that.drawLine()
                        that.drawLine2()
                        that.drawLine3()
                        that.drawLine4()
                        that.drawLine5()
                    })

                    // that.sel = setInterval(function () {
                    //     that.DataList = [that.arr.slice(that.i, that.i + 14)]
                    //     that.xData = that.arr2.slice(that.i, that.i + 14)
                    //     that.DataList2 = [that.arr3.slice(that.i, that.i + 14)]
                    //     that.xData2 = that.arr4.slice(that.i, that.i + 14)
                    //     that.DataList3 = [that.arr5_A.slice(that.i, that.i + 14), that.arr5_B.slice(that.i, that.i + 14), that.arr5_C.slice(that.i, that.i + 14)]
                    //     that.xData3 = that.arr6.slice(that.i, that.i + 14)
                    //     that.DataList4 = [that.arr7_W.slice(that.i, that.i + 14), that.arr7_S.slice(that.i, that.i + 14)]
                    //     that.xData4 = that.arr8.slice(that.i, that.i + 14)
                    //     that.i++;
                    //     // if (that.i > (that.arr.length - 14) || that.i > (that.arr3.length - 14) || that.i > (that.arr5_A.length - 14) || that.i > (that.arr7_W.length - 14)) {
                    //     //     clearInterval(that.sel);
                    //     // }
                    //     that.drawLine()
                    //     that.drawLine2()
                    //     that.drawLine3()
                    //     that.drawLine4()
                    // }, 10000)
                    that.loading = false
                }


            }).catch(() => {
                that.loading = false
            });

        },

        getData1() {
            var that = this
            that.loading1 = true
            if (!this.formselect.deviceId) {
                this.$message.warning(this.$t('PleaseSelectDevice'))
                that.loading1 = false
                return
            }
            // this.formselect.startTime = this.selectTime[0]
            // this.formselect.endTime = this.selectTime[1]
            //this.i = 0;
            //this.formselect.deviceCode = getDeviceNameByid(this.formselect.deviceId, JSON.parse(sessionStorage.getItem("area"))).label
            GetByDeviceCode(this.formselect.deviceId).then(res => {
                if (res.success) {
                    this.formselect.deviceCode = res.result.deviceCode;
                    this.formselect.deviceName = res.result.deviceName;
                    connection.on(res.result.deviceCode, this.TempHumdata);
                    // that.$nextTick(() => {
                    //             that.drawLine6()

                    //         })
                    var data = this.formselect
                    GetHumCurveData(data).then(res => {
                        if (res.success) {


                            that.result = res.result

                            that.result.humList.map(item => {

                                let iTs = getLocalTime(item.iTs)
                                that.arr_h.push(item.humValue)

                            })
                            that.result.tempList.map(item => {
                                item.iTs = getLocalTime(item.iTs)
                                that.arr_t.push(item.tempValue)
                                that.arr_time.push(item.iTs)
                            })

                            that.h = that.arr_t.length;
                            this.xData.length = this.arr_time.length;
                            //chart1
                            if (that.h > 1000) {
                                that.DataList6 = [that.arr_t.slice(that.h - 1000, that.h), that.arr_h.slice(that.h - 1000, that.h)]
                                that.xData6 = that.arr_time.slice(that.h - 1000, that.h)
                            } else {
                                that.DataList6 = [that.arr_t, that.arr_h]
                                that.xData6 = that.arr_time
                            }
                            that.$nextTick(() => {
                                that.drawLine6()

                            })
                            that.loading1 = false

                        }
                    }).catch(() => {
                        that.loading1 = false
                    });

                }
            })





        },

        beforeDestroy() {
            clearInterval(this.sel);
        },
        getAreaList(e) {

            this.formselect = { ...this.formselect, ...e.Valueform }
        },
        dataL(e, i) {
            //  
            var DataL = [];
            let elen = 0;
            if (e.length > 0) {
                elen = e[i].length
            }

            for (var j = 0; j < elen; j++) {
                var tempD = [];
                if (e[i][j] > 300) {
                    tempD = {
                        value: e[i][j],
                        itemStyle: {
                            color: 'red'//数据异常的话，显示折点 为红色
                        }
                    };
                } else {
                    tempD = {
                        value: e[i][j],
                    };
                }
                DataL.push(tempD);
            }
            return DataL;
        },

        drawLine() {
            var chart1 = echarts.init(document.getElementById('chart1'))
            var NameList = [this.$t('InstantaneousTotalPower')];
            var color = ['#2EC7C9',];
            var series = [];
            for (var i = 0; i < NameList.length; i++) {
                var tempS = {
                    // name: NameList[i],
                    type: "line",
                    symbolSize: 7,
                    symbol: 'emptyCircle',
                    lineStyle: {
                        color: color[i]
                    },
                    itemStyle: {
                        borderWidth: 2,
                        color: color[i]

                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: color[i]
                            },
                            {
                                offset: 1,
                                color: 'rgba(235,238,245,0)'
                            }
                            ], false),
                            shadowColor: 'rgba(0,0,0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    data: this.dataL(this.DataList, i)

                };
                series.push(tempS)
            }

            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: this.$t('InstantaneousTotalPower'),
                    textStyle: {
                        overflow: "break",
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: NameList,
                    top: 25,
                    left: 5,
                    textStyle: {
                        fontSize:10
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xData,
                },
                yAxis: {
                    type: 'value'
                },
                series: series
            };
            chart1.setOption(option);
        },
        drawLine2() {
            var chart1 = echarts.init(document.getElementById('chart2'))
            var NameList = [this.$t('PowerFactor')];
            var color = ['#2EC7C9', '#B6A2DE', '#63C2FF', '#FFB980', '#F071B4', '#8D98B3', '#E5CF0D', '#97B552', '#95706D', '#DC69AA'];
            var series = [];
            for (var i = 0; i < NameList.length; i++) {
                var tempS = {
                    // name: NameList[i],
                    type: "line",
                    symbolSize: 7,
                    symbol: 'emptyCircle',
                    lineStyle: {
                        color: color[i]
                    },
                    itemStyle: {
                        borderWidth: 2,
                        color: color[i]

                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: color[i]
                            },
                            {
                                offset: 1,
                                color: 'rgba(235,238,245,0)'
                            }
                            ], false),
                            shadowColor: 'rgba(0,0,0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    data: this.dataL(this.DataList2, i)

                };
                series.push(tempS)
            }

            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: this.$t('PowerFactor'),
                    textStyle: {
                        overflow: "break",
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: NameList ,
                    top: 25,
                    left: 5,
                    textStyle: {
                        fontSize:10
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xData2,
                },
                yAxis: {
                    type: 'value'
                },
                series: series
            };
            chart1.setOption(option);
        },
        drawLine3() {
            var chart1 = echarts.init(document.getElementById('chart3'))
            var NameList = [this.$t('PhaseACurrent') + '(A)', this.$t('PhaseBCurrent') + '(A)', this.$t('PhaseCCurrent') + '(A)'];
            var color = ['#2EC7C9', '#B6A2DE', '#63C2FF', '#FFB980', '#F071B4', '#8D98B3', '#E5CF0D', '#97B552', '#95706D', '#DC69AA'];
            var series = [];
            for (var i = 0; i < NameList.length; i++) {
                var tempS = {
                    name: NameList[i],
                    type: "line",
                    symbolSize: 7,
                    symbol: 'emptyCircle',
                    lineStyle: {
                        color: color[i]
                    },
                    itemStyle: {
                        borderWidth: 2,
                        color: color[i]

                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: color[i]
                            },
                            {
                                offset: 1,
                                color: 'rgba(235,238,245,0)'
                            }
                            ], false),
                            shadowColor: 'rgba(0,0,0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    data: this.dataL(this.DataList3, i)

                };
                series.push(tempS)
            }

            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: this.$t('3PhaseCurrent'),
                    textStyle: {
                        overflow: "break",
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: NameList,
                    top: 25,
                    left: 5,
                    textStyle: {
                        fontSize:10
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xData3,
                },
                yAxis: {
                    type: 'value'
                },
                series: series
            };
            chart1.setOption(option);
        },
        drawLine4() {
            var chart1 = echarts.init(document.getElementById('chart4'))
            var NameList = [this.$t('InstantaneousActivePower') + '(VA)', this.$t('ApparentPower') + '(VA)'];
            var color = ['#2EC7C9', '#B6A2DE', '#63C2FF', '#FFB980', '#F071B4', '#8D98B3', '#E5CF0D', '#97B552', '#95706D', '#DC69AA'];
            var series = [];
            for (var i = 0; i < NameList.length; i++) {
                var tempS = {
                    name: NameList[i],
                    type: "line",
                    symbolSize: 7,
                    symbol: 'emptyCircle',
                    lineStyle: {
                        color: color[i]
                    },
                    itemStyle: {
                        borderWidth: 2,
                        color: color[i]

                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: color[i]
                            },
                            {
                                offset: 1,
                                color: 'rgba(235,238,245,0)'
                            }
                            ], false),
                            shadowColor: 'rgba(0,0,0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    data: this.dataL(this.DataList4, i)

                };
                series.push(tempS)
            }

            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: this.$t('InstantaneousActivePower') + '+' + this.$t('ApparentPower'),
                    textStyle: {
                        overflow: "break",
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: NameList,
                    top: 25,
                    left: 5,
                    textStyle: {
                        fontSize:10
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xData4,
                },
                yAxis: {
                    type: 'value'
                },
                series: series
            };
            chart1.setOption(option);
        },
        drawLine5() {
            var chart1 = echarts.init(document.getElementById('chart5'))
            var NameList = [this.$t('PhaseAVoltage') + '(V)', this.$t('PhaseBVoltage') + '(V)', this.$t('PhaseCVoltage ') + '(V)'];
            var color = ['#2EC7C9', '#B6A2DE', '#63C2FF', '#FFB980', '#F071B4', '#8D98B3', '#E5CF0D', '#97B552', '#95706D', '#DC69AA'];
            var series = [];
            for (var i = 0; i < NameList.length; i++) {
                var tempS = {
                    name: NameList[i],
                    type: "line",
                    symbolSize: 7,
                    symbol: 'emptyCircle',
                    lineStyle: {
                        color: color[i]
                    },
                    itemStyle: {
                        borderWidth: 2,
                        color: color[i]

                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: color[i]
                            },
                            {
                                offset: 1,
                                color: 'rgba(235,238,245,0)'
                            }
                            ], false),
                            shadowColor: 'rgba(0,0,0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    data: this.dataL(this.DataList5, i)

                };
                series.push(tempS)
            }

            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: this.$t('3PhaseVoltage'),
                    textStyle: {
                        overflow: "break",
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: NameList,
                    top: 25,
                    left: 5,
                    textStyle: {
                        fontSize:10
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xData5,
                },
                yAxis: {
                    type: 'value'
                },
                series: series
            };
            chart1.setOption(option);
        },
        drawLine6() {
            var chart1 = echarts.init(document.getElementById('chart6'))
            var NameList = [this.$t('Temperature') + '(°C)', this.$t('Humidity') + '(%RH)'];
            var color = ['#2EC7C9', '#B6A2DE', '#63C2FF', '#FFB980', '#F071B4', '#8D98B3', '#E5CF0D', '#97B552', '#95706D', '#DC69AA'];
            var series = [];
            for (var i = 0; i < NameList.length; i++) {
                var tempS = {
                    name: NameList[i],
                    type: "line",
                    symbolSize: 7,
                    symbol: 'emptyCircle',
                    lineStyle: {
                        color: color[i]
                    },
                    itemStyle: {
                        borderWidth: 2,
                        color: color[i]

                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: color[i]
                            },
                            {
                                offset: 1,
                                color: 'rgba(235,238,245,0)'
                            }
                            ], false),
                            shadowColor: 'rgba(0,0,0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    data: this.dataL(this.DataList6, i)

                };
                series.push(tempS)
            }

            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: this.$t('Temperature') + '+' + this.$t('Humidity'),
                    textStyle: {
                        overflow: "break",
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: NameList,
                    top: 25,
                    left: 5,
                    textStyle: {
                        fontSize:10
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xData6,
                },
                yAxis: {
                    type: 'value'
                },
                series: series
            };
            chart1.setOption(option);
        },
    },
    computed: mapState({
        isCollapse: state => state.isCollapse
    }),
}
</script>

<style scoped></style>
